import EstablishmentsApi from 'api-client/Establishments.api'
import StoreConnector from '@/helpers/StoreConnector'

const EstablishmentsService = {
  async getEstablishments() {
    try {
      const result = await EstablishmentsApi.getEstablishments()
      StoreConnector.dispatch('establishments/setEstablishments', result)
      return Promise.resolve()
    } catch (e) {
      return Promise.resolve()
    }
  },
}

export default EstablishmentsService
